export default __webpack_public_path__ + "static/media/android_badge_black.a2c48571.png";